module.exports = __webpack_public_path__ + "img/match_share.923e8f39.png";